import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastyService } from 'ng2-toasty';
import { Prize } from '../prize.model';
import { PrizesService } from '../prizes.service';

@Component({
  selector: 'app-edit-prize',
  templateUrl: './edit-prize.component.html',
  styleUrls: ['./edit-prize.component.scss']
})
export class EditPrizeComponent implements OnInit {

  prizeForm = new FormGroup ( {
    title: new FormControl ('', [Validators.required]),
    subtitle: new FormControl (''),
    description: new FormControl ('', [Validators.required]),
    image: new FormControl (''),
    link: new FormControl (''),
  })

  prize: Prize = {};

  constructor(
    private prizesService: PrizesService,
    private toastyService: ToastyService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const prizeId = this.activatedRoute.snapshot.params.id;
    this.prizesService.getOnePrize(prizeId).subscribe((res: {data: Prize, message: string}) => {
      this.prize = res.data;
      this.populateForm();
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

  // convenience getter for easy access to form fields
  get f(): any {
    return this.prizeForm.controls;
  }

  populateForm(): void {
    this.f.title.setValue(this.prize.title);
    this.f.subtitle.setValue(this.prize.subtitle);
    this.prize.image ? this.f.image.setValue(this.prize.image) : '';
    this.f.description.setValue(this.prize.description);
    this.f.link.setValue(this.prize.link);
  }

  setImageUrl(event): void {
    console.log('event', event);
    this.f.image.setValue(event ? event.filename : null);
  }

  editPrize(): void {
    this.prizesService.editPrize(this.prizeForm.value, this.prize.id)
    .subscribe((res: {data: any}) => {
      this.toastyService.success({
        title: 'Prize salvato',
        msg: 'Il tuo prize "<b>' + res.data.title + '</b>" è stato salvato correttamente.'
      });
      this.router.navigate(['/prizes']);
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

}
